<template>
  <form ref="formRef" class="form-edit">
    <div
      v-for="(component, index) in components"
      :key="component._uuid"
    >
      <component
        :is="`${component.type}-field`"
        v-show="!$checkConditionalViewAllow(component, components, variables, json)"
        :component="component"
        :index="index"
      />
    </div>
  </form>
</template>

<script>
// Vuex
// https://vuex.vuejs.org/guide/state.html#the-mapstate-helper
import { mapState } from 'vuex'
// Components
import TextField from '@/components/text/TextField.vue'
import PasswordField from '@/components/password/PasswordField.vue'
import NumberField from '@/components/number/NumberField.vue'
import SelectField from '@/components/select/SelectField.vue'
import SelectApiField from '@/components/select-api/SelectApiField.vue'
import SelectResourceField from '@/components/select-resource/SelectResourceField.vue'
import TextareaField from '@/components/textarea/TextAreaField.vue'
import CheckboxSingleField from '@/components/checkbox-single/CheckboxSingleField.vue'
import CheckboxField from '@/components/checkbox/CheckboxField.vue'
import RadioField from '@/components/radio/RadioField.vue'
import FileField from '@/components/file/FileField.vue'
import DatepickerField from '@/components/datepicker/DatepickerField.vue'
import HelpBlockField from '@/components/help-block/HelpBlockField.vue'
import GroupField from '@/components/group/GroupField.vue'
import formTransformer from '@/services/formTransformer'

export default {
  props: ['components'],
  name: 'FormEdit',
  components: {
    TextField,
    PasswordField,
    NumberField,
    SelectField,
    SelectApiField,
    SelectResourceField,
    TextareaField,
    CheckboxSingleField,
    CheckboxField,
    RadioField,
    FileField,
    DatepickerField,
    HelpBlockField,
    GroupField
  },
  computed: {
    // The mapState Helper
    // https://vuex.vuejs.org/guide/state.html#the-mapstate-helper
    ...mapState({
      config: state => state.config,
      variables: state => state.config.variables,
      json: state => state.config.json
    })
  },
  methods: {
    applyOutputFormat: function (value, format) {
      if (!value) {
        return ''
      }
      let day = value.substring(0, 2)
      let month = value.substring(2, 4)
      let year = value.substring(4, 8)

      return format.replace(/DD/g, day).replace(/MM/g, month).replace(/YYYY/g, year)
    },
    /**
     * Envia para o SDK o retorno da validação do formulário
     * @param  {Object} form   Objeto do formulário com key e value
     * @param  {Boolean} status Status da validação do formulário
     */
    sendValidate: function (form, status) {
      const milliseconds = new Date().getTime()
      const payload = {
        origin: 'formBuilderWebRender',
        client: this.config.identifier,
        type: 'message',
        message: 'validate',
        data: {
          clientKey: this.config.clientKey,
          idForm: this.config.idForm,
          status: status,
          msg: status ? 'Formulário validado com sucesso.' : 'Formulário inválido.',
          data: form
        },
        timestamp: milliseconds
      }
      window.parent.postMessage(payload, '*')
    },
    getFormData() {
      const form = {}
      this.$children.forEach(parent => {
        if (parent.component.data) {
          if (parent.component.data.outputFormat) {
            form[parent.component.key] = this.applyOutputFormat(parent.component.data.currentValue, parent.component.data.outputFormat)
          } else {
            form[parent.component.key] = parent.component.data.currentValue
          }
        }
        if (parent.component.components) {
          parent.$children.forEach(c => {
            if (c.component.data) {
              if (c.component.data.outputFormat) {
                form[c.component.key] = this.applyOutputFormat(c.component.data.currentValue, c.component.data.outputFormat)
              } else {
                form[c.component.key] = c.component.data.currentValue
              }
            }
          })
        }
      })
      return form;
    },
    /**
     * Verifica as validações do formulário e envia o resultado
     * para o metodo sendValidate
     * @param  {Object} payload Objeto da mensagem recebida
     */
    validate: function (payload) {
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            this.sendValidate(this.getFormData(), true)
          } else {
            this.sendValidate({}, false)
            console.log('oi')
          }
        })
      if ((payload || {}).origin === 'formBuilderSDK') {
        if (payload.type === 'command' && payload.action === 'validate') {
        }
      }
    },
    messageHandler: function (event) {
      const payload = event.data
      if (payload.type === 'command' && payload.origin === 'formBuilderSDK') {
        if (payload.action === 'validate') {
          this.validate(payload)
        }
      }
    }
  },
  created () {
    this.$bindEvent(window, 'message', (e) => this.messageHandler(e))
  },
  mounted () {
    formTransformer.registerFormRef(this.$refs.formRef)
  }
}
</script>
